import showWaveEffect from './WaveEffect';
export default function useWave(nodeRef, className) {
    function showWave() {
        const node = nodeRef.current;
        showWaveEffect(node, className);
    }
    return showWave;
}
